import { useState, useEffect } from 'react';
import { Tabs, Space } from 'antd';
import type { TabsProps } from 'antd';
import { Button, Form, Spin } from 'antd';
import { UserOutlined, ContactsOutlined } from '@ant-design/icons';
import axios from 'axios';
import Tab1 from './Tab1';
import Utilisateur from '../../../Models/Utilisateur';
import { useAuthHeader, useAuthUser } from '../../../Services/Auth/sessionAuth';
import Data from '../../../Data/Data.json';
import SweetAlert from "sweetalert2"
import { Crypter } from '../../../Functions/Security/Crypter';
import { Box, Typography } from '@mui/material';
import Tab2 from './Tab2';
import ReformatDate from '../../../Functions/Traitement/ReformatDate';
import CLIENT from '../../../Models/Client';
import { emphasize, styled } from '@mui/material/styles';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Chip from '@mui/material/Chip';
import HomeIcon from '@mui/icons-material/Home';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import InputForm from '../../InputT';
import { Tab3 } from './Tab3';
import Tab4 from './Tab4';
import GetElement from '../../../Models/GetEmelment';
import "../../../Styles/StyleHome.css";
import VerifDay from '../../../Functions/Traitement/VerifDay';
import { useNavigate } from 'react-router-dom';
import Help from '../../../Types/Help';
import HelpInfos from '../../HelpInfo';
import HelpData from '../../../Data/Help.json';

//import "../../Assets/Styles/StyleForm.css";

//CreateNewCLIENT
//const Swal = require('sweetalert2');
//let LinkSourceApi= require('../../Data/Data.json');

const StyledBreadcrumb = styled(Chip)(({ theme }) => {
  const backgroundColor =
    theme.palette.mode === 'light'
      ? theme.palette.grey[100]
      : theme.palette.grey[800];
  return {
    backgroundColor,
    height: theme.spacing(3),
    color: theme.palette.text.primary,
    fontWeight: theme.typography.fontWeightRegular,
    '&:hover, &:focus': {
      backgroundColor: emphasize(backgroundColor, 0.06),
    },
    '&:active': {
      boxShadow: theme.shadows[1],
      backgroundColor: emphasize(backgroundColor, 0.12),
    },
  };
}) as typeof Chip;

//client Physique
const ClientPhys = () => {
  // USER SESSION
  const auth = useAuthUser()
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()))

  // USER TOKEN
  const authHeader = useAuthHeader()

  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [StartSearchG, SeStartSearchG] = useState(false);
  const [StartForm, SetStartForm] = useState(true);
  const [, forceUpdate] = useState({});
  const [photo, setphoto] = useState<any>("");
  const [Signature, setSignature] = useState<any>("");
  const [isSubmit, setIsSubmit] = useState(false)
  const [ajoutActve, setAjoutActif] = useState(false)
  const [modifActve, setModifActve] = useState(true)
  const [enregActve, setEnregActve] = useState(true)
  const [supActive, setSupActive] = useState(true)
  const [impActive, setImpActive] = useState(true)
  const [actuActive, setActActive] = useState(true)
  const [annulActive, setAnnulActive] = useState(true)
  const [consulActive, setConsulActive] = useState(false)
  const [sbmit, setSbmit] = useState("");
  const [Activetabs, SetActivetabs] = useState(false);
  const [Load, SetLoad] = useState(false);
  const Navigate = useNavigate();

  useEffect(() => {
    forceUpdate({});
    if (Load === false) {
      VerifDay(user.coduti, user.codage, authHeader, Navigate);
      SetLoad(true);
    }
  }, []);

  function initialiazeButton() {
    SeStartSearchG(false)
    setAjoutActif(false)
    setModifActve(true)
    setEnregActve(true)
    setSupActive(true)
    setImpActive(true)
    setActActive(true)
    setAnnulActive(true)
    setConsulActive(false)
  }

  const SetStart = () => {
    setSbmit("add")
    SeStartSearchG(true)
    setModifActve(true)
    setAjoutActif(true)
    setEnregActve(false)
    setAnnulActive(false)
    setConsulActive(true)
    form.resetFields()
    form.setFieldValue("ValCli", 'N');
    form.setFieldValue("niveau", 900)
  }

  const SetEndStart = () => {
    SetStartForm(true);
    SeStartSearchG(false)
  }
  function handleAnulle() {
    SetActivetabs(false)
    let coduti = form.getFieldValue("CODUTI")
    form.resetFields()
    localStorage.clear()
    form.setFieldValue("CODUTI", coduti)
    initialiazeButton()
    localStorage.setItem(Data.LocalVariable.reset, "1")
    SeStartSearchG(false)
    //localStorage.setItem(Data.LocalVariable.resetTable, "1")
  }

  function cunsultButton() {
    setAnnulActive(false)
  }

  function modifButton() {
    setSbmit("update")
    setModifActve(true)
    setAjoutActif(true)
    SeStartSearchG(true)
    setEnregActve(false)
    setConsulActive(true)
    SetActivetabs(false)
  }


  const items: TabsProps['items'] =
    [
      {
        key: '1',
        label: (
          <span>
            <UserOutlined />
            Information Client
          </span>
        ),
        children: <Tab1 etatG={StartSearchG} form={form} />,
      },
      {
        key: '2',
        label: (
          <span>
            <ContactsOutlined />
            Autres informations Client
          </span>
        ),
        children: <Tab2 form={form} />,
      }
      ,
      {
        key: '3',
        label: (
          <span>
            <ContactsOutlined />
            Photo et Signature
          </span>
        ),
        children: <Tab3 form={form} photo={photo} signature={Signature} />,
      },
      {
        key: '4',
        label: (
          <span>
            <ContactsOutlined />
            Informations Complémentaires
          </span>
        ),
        children: <Tab4 form={form} />,
      }
    ];

  const onFinish = (values: any) => {
    var Client: CLIENT = values
    Client.TYPCLI = "P"
    Client.UTILIS = user.coduti;
    Client.CODAGE = user.codage;
    Client.DateDelcni = (new Date(Client.DateDelcni)).toLocaleDateString("fr").replaceAll('/', '-') + " 00:00:00"
    Client.DATNAI = (new Date(Client.DATNAI)).toLocaleDateString("fr").replaceAll('/', '-') + " 00:00:00"

    if ((typeof form.getFieldValue("Signature") !== 'undefined') && (typeof form.getFieldValue("Photo") !== 'undefined') && form.getFieldValue("Photo") ? form.getFieldValue("Photo") : "" !== "" && form.getFieldValue("Photo") ? form.getFieldValue("Signature") : "" !== "") {
      if (sbmit == "add") {
        Client.DATCRE = (new Date(user.datjour)).toLocaleDateString("fr").replaceAll("/", '-');

        SweetAlert.fire({
          title: "Enregistrement du client",
          text: "Voulez-vous enregistrer le client " + Client.PRECLI + " " + Client.NOMCLI + " ?",
          showCancelButton: true,
          color: "#116599",
          confirmButtonText: "Yes",
          confirmButtonColor: "#116599",
          cancelButtonColor: "darkred",
          cancelButtonText: "No",
          showLoaderOnConfirm: true,
          icon: 'question'
        }).then((res) => {
          if (res.isConfirmed) {
            setLoading(true);
            setIsSubmit(true)
            //let group = profilsDistant.find(()=>)
            console.log('Received values of form: ', Crypter.encrypt(JSON.stringify(Client)));

            let data = Crypter.encrypt(JSON.stringify(Client));

            let config =
            {
              method: 'post',
              maxBodyLength: Infinity,
              url: Data.ApiUrl.CreateNewCLIENT,
              headers: {
                // 'CypherClient': data,
                'Authorization': authHeader(),
                'Content-Type': 'application/json'
              },
              data: data
            };

            axios.request(config)
              .then((response) => {
                setLoading(false);
                if (response.data) {
                  const res = JSON.parse(Crypter.decrypt(response.data));

                  if (res.StatutCode == 200) {
                    form.resetFields()
                    localStorage.clear()
                    setIsSubmit(false)
                    SweetAlert.fire({ title: res.Message, text: res.Result, icon: "success" })

                    localStorage.clear()
                    initialiazeButton()

                    setSbmit("")
                  }
                  else {
                    SweetAlert.fire({ title: res.Message, text: res.Result, icon: "warning" })
                  }
                }
              })
              .catch((error) => {
                setLoading(false);
                console.log(error)
                SweetAlert.fire({ title: "Error", text: error.message, icon: "error" })
              });
          }
        }
        )
      }
      // if (sbmit == "update") {
      //   Client.DATMAJ = (new Date(user.datjour)).toLocaleDateString("fr").replaceAll("/", '-');
      //   Client.CDETAT = '01';
      //   //console.log(values)
      //   SweetAlert.fire({
      //     title: "Modification du Client",
      //     text: "Voulez-vous modifier le client " + Client.NUMCLI + " ?",
      //     showCancelButton: true,
      //     color: "#116599",
      //     confirmButtonText: "Yes",
      //     confirmButtonColor: "#116599",
      //     cancelButtonColor: "darkred",
      //     cancelButtonText: "No",
      //     showLoaderOnConfirm: true,
      //     icon: 'question'
      //   }).then((res) => {
      //     if (res.isConfirmed) {
      //       setLoading(true);
      //       setIsSubmit(true)

      //       console.log('Received values of form: ', Client);

      //       let data = Crypter.encrypt(JSON.stringify(Client));

      //       let config = {
      //         method: 'put',
      //         maxBodyLength: Infinity,
      //         url: Data.ApiUrl.UpdateClient,
      //         headers: {
      //           // 'CypherClient': data,
      //           'Authorization': authHeader(),
      //           'Content-Type': 'application/json'
      //         },
      //         data: data
      //       };

      //       axios.request(config)
      //         .then((response) => {
      //           setLoading(false);
      //           if (response.data) {
      //             const res = JSON.parse(Crypter.decrypt(response.data));

      //             if (res.StatutCode == 200) {
      //               form.resetFields()
      //               localStorage.clear()
      //               setIsSubmit(false)
      //               SweetAlert.fire({ title: res.Message, text: res.Result, icon: "success" });

      //               initialiazeButton()
      //               localStorage.setItem(Data.LocalVariable.reset, '1');

      //               setSbmit("");
      //             }
      //             else {
      //               SweetAlert.fire({ title: res.Message, text: res.Result, icon: "warning" })
      //             }
      //           }
      //         })
      //         .catch((error) => {
      //           setLoading(false);
      //           console.log(error)
      //           SweetAlert.fire({ title: "Error", text: error.message, icon: "error" })
      //         });
      //     }
      //   })
      // }

    } else SweetAlert.fire({ title: "Requirement ", text: "veuillez inserer la photo et la signature  du client ", icon: "warning" })

  };

  const onFinishFailed = async (errorInfo: any) => {
    var errors: any = [];

    errorInfo.errorFields.map((error: any) => {

      errors.push(error.name + "");
    })

    SweetAlert.fire({ title: "Veuillez remplir tous les champs obligatoires", text: errors.toString().replaceAll(',', " - "), icon: 'warning', confirmButtonText: 'OK' })

  };

  function consult() {
    let data = form.getFieldValue("NUMCLI") ? form.getFieldValue("NUMCLI") : '';
    let clearNumcli = form.getFieldValue("NUMCLI");

    if (data.length != 0) {
      initialiazeButton()
      setLoading(true)
      form.resetFields();
      form.setFieldValue("NUMCLI", clearNumcli);
      let getelement = new GetElement(clearNumcli, user.coduti, "", '02', user.codage);
      // let clearNumcli = form.getFieldValue("NUMCLI");
      let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: Data.ApiUrl.GetClientTmp,
        headers: {
          'CypherGetElement': Crypter.encrypt(JSON.stringify(getelement)),
          'Authorization': authHeader(),
          'Content-Type': 'application/json'
        },
      };
      axios.request(config)
        .then((response) => {
          setLoading(false);
          if (response.data) {
            const res = JSON.parse(Crypter.decrypt(response.data));

            if (res.StatutCode == 200) {
              let datas: CLIENT = res.Result.Table[0]

              if (res.Result.Table.length > 0) {
                if (datas.TYPCLI.toUpperCase() == 'P') {

                  form.setFieldsValue(res.Result.Table[0]);
                  if (clearNumcli.indexOf('T') !== -1) setModifActve(false)
                  else setModifActve(true)

                  SetActivetabs(true);
                  form.setFieldValue('lib_NUMCLI', datas.NOMCLI)
                  setphoto(datas.Photo);
                  setSignature(datas.Signature);
                  form.setFieldValue('DATNAI', ReformatDate(datas.DATNAI));
                  form.setFieldValue('DateDelcni', ReformatDate(datas.DateDelcni));
                  form.setFieldValue("lib_NUMCLI", form.getFieldValue("NOMCLI"))
                  form.setFieldValue("DATCRE", datas.DATCRE ? (new Date(datas.DATCRE.substring(0, 10))).toLocaleDateString("fr") : '')
                  cunsultButton();
                }
                else {
                  SweetAlert.fire({ title: res.Message, text: res.Result, icon: "warning" })
                }
              } else {
                SweetAlert.fire({ title: "Warning", text: "Client not found", icon: "warning" })
              }
            }
            else {
              SweetAlert.fire({ title: "Warning", text: res.Result, icon: "warning" })
            }
          }
          setLoading(false)
        })
        .catch((error) => {
          setLoading(false);
          console.log(error)
          SweetAlert.fire({ title: "Error", text: error.mesage, icon: "error" })
        });
    } else SweetAlert.fire({ title: "veuillez saisir l'indice", text: "", icon: "question" })
  }

  function modif() {
    modifButton()
  }


  const HelpInfo: Help[] =
    [
      {
        Titre: "Espace Client",
        Description: "Ce module permet d'effectuer la creation , modification et consultaion d'un client bien vouloir suive la documentation préscrit si dessous",
        SousHelp:
          [
            {
              Titre: "Ajouter un client",
              Description: "",
              SousHelp:
                [
                  {
                    Titre: "Etape 1",
                    Description: " Cliquez sur le boutton Ajouter puis remplir correctements les champs",
                    SousHelp:
                      [

                      ]
                  },
                  {
                    Titre: "Notez Bien",
                    Description: "Les champs avec l'étoile rouge sont obligatoires",
                    SousHelp:
                      [

                      ]
                  }
                ]
            },
            {
              Titre: "Consulter un client existant",
              Description: " ",
              SousHelp: []
            }
          ]
      },
      {
        Titre: "Mesure de prudence",
        Description: "Ce module permet d'effectuer la creation , modification et consultaion d'un client bien vouloir suive la documentation préscrit si dessous",
        SousHelp: [],
      }
    ]

  return (
    <div className='tab'>
      <Box className='formTitle'> <Breadcrumbs aria-label="breadcrumb">
        <StyledBreadcrumb
          component="a"
          href="/jjh"
          label="Home"
          icon={<HomeIcon fontSize="small" />}
        />
        <StyledBreadcrumb component="a" href="#" label="Gestion" />
        <StyledBreadcrumb
          label="CLIENT PHYSIQUE"
          deleteIcon={<ExpandMoreIcon />}

        />
      </Breadcrumbs></Box>
      {/* <Typography align='center' className='formTitle'><b>GESTION CLIENT PHYSIQUE : {window.location.pathname}</b></Typography> */}
      <Spin spinning={loading} size='large' style={{ color: '#116599' }} >
        <Form disabled={!ajoutActve} autoComplete="off" labelAlign='left' form={form} name="dynamic_form_complex" onFinish={onFinish} onFinishFailed={onFinishFailed} style={{ minWidth: 'auto', maxWidth: 'auto' }} >
          <div className='bG'>
            <legend><Typography color={"#116599"}>Actions</Typography></legend>
            <Form.Item shouldUpdate className='bouttong'>
              <Space direction="vertical" style={{ width: '100%' }}>

                <Button size='large' className='bt_add' disabled={consulActive} onClick={consult} type="ghost" htmlType="button" block  >
                  Consulter
                </Button>

                <Button size='large' className='bt_add' disabled={ajoutActve} onClick={SetStart} type="ghost" htmlType="button" block  >
                  Ajouter
                </Button>
                <Button size='large' className='bt_add' disabled={modifActve} onClick={modif} type="ghost" htmlType="button" block  >
                  Modifier
                </Button>
                <Button size='large' className='bt_add' disabled={enregActve} type="ghost" htmlType="submit" block>
                  Enregistrer
                </Button>
                <Button size='large' className='bt_add' onClick={SetEndStart} disabled={supActive} type="ghost" htmlType="button" block>
                  Supprimer
                </Button>
                <Button size='large' className='bt_add' disabled={impActive} type="ghost" htmlType="button" block  >
                  Aperçu
                </Button>
                <Button size='large' className='bt_add' disabled={actuActive} type="ghost" htmlType="button" block  >
                  Actualiser
                </Button>
                <Button size='large' disabled={annulActive} onClick={handleAnulle} className='bt_add' type="ghost" htmlType="reset" block>
                  Annuler
                </Button>
              </Space>
            </Form.Item>
          </div>
          <div className='clientP'>
            <div >
              <Tabs style={{ overflowX: 'scroll', msOverflowY: 'scroll' }} onChange={e => { if (Activetabs == true) { consult() } }} size='large' type="card" items={items} />
              
            <HelpInfos helpInfo={HelpData.GestionClient.ClientPhysique as Help} />
            </div>
            <div>
            </div>
          </div>
        </Form>
      </Spin>
    </div>
  );


}

export default ClientPhys;

